import {
  AuthProvider,
  ContactProvider,
  OidcProvider,
  PowerAppsProvider,
  PreviewAuthProvider,
  PreviewContactProvider,
  PreviewOidcProvider,
  PreviewPowerAppsProvider,
} from '@/context';
import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { DialogsProvider } from '../context/Dialogs';
import { MessageProvider } from '../context/Message';
import configuration from '../ssoConfig';

// Don't change Providers order
// 1. CookiesProvider
// 2. MessageProvider
// 3. DialogsProvider
// 4. OidcProvider
// 5. PowerAppsProvider
// 6. AuthProvider
// 7. ContactProvider

export const AuthProviders = ({
  children,
  isPreview,
}: {
  children: React.ReactNode;
  isPreview: boolean;
}) => (
  <CookiesProvider>
    <MessageProvider>
      <DialogsProvider>
        {isPreview ? (
          <PreviewOidcProvider>
            <PreviewPowerAppsProvider>
              <PreviewAuthProvider>
                <PreviewContactProvider>{children}</PreviewContactProvider>
              </PreviewAuthProvider>
            </PreviewPowerAppsProvider>
          </PreviewOidcProvider>
        ) : (
          <OidcProvider configuration={configuration}>
            <PowerAppsProvider>
              <AuthProvider>
                <ContactProvider>{children}</ContactProvider>
              </AuthProvider>
            </PowerAppsProvider>
          </OidcProvider>
        )}
      </DialogsProvider>
    </MessageProvider>
  </CookiesProvider>
);
